import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('eye_of_ra', {
  cherry: 'sun_amulet',
  lemon: 'falcon_feather',
  orange: 'was_scepter',
  bell: 'solar_boat',
  star: 'horus_falcon_wild',
  seven: 'obelisk',
  gem: 'sun_gem',
  scatter: 'eye_of_ra_scatter',
  money: 'sun_disc_hoard',
});

/** Eye of Ra — GENERATED by scaffoldSlot from
 *  content/slots/eye_of_ra.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const EYE_OF_RA_THEME: Theme = {
  id: 'eye_of_ra',
  name: 'Eye of Ra',
  palette: {
    accent: 0xf2c23a,
    secondary: 0xe0682e,
    warm: 0xfff0b0,
    frameFill: 0x2a1c0a,
    bgGradientTop: 0x3a2810,
    bgGradientBottom: 0x140c03,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Sun Amulet', glyph: '🔆', tint: 0xF2C23A, weight: 5, textureAlias: 'eye_of_ra:cherry',
        winVideoAlias: 'eye_of_ra:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Falcon Feather', glyph: '🪶', tint: 0xE0A52E, weight: 5, textureAlias: 'eye_of_ra:lemon',
        winVideoAlias: 'eye_of_ra:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Was Scepter', glyph: '🪄', tint: 0xE0682E, weight: 4, textureAlias: 'eye_of_ra:orange',
        winVideoAlias: 'eye_of_ra:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Solar Boat', glyph: '⛵', tint: 0xF2C23A, weight: 3, textureAlias: 'eye_of_ra:bell',
        winVideoAlias: 'eye_of_ra:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Horus', glyph: '🦅', tint: 0xFFF0B0, weight: 2, textureAlias: 'eye_of_ra:star',
        winVideoAlias: 'eye_of_ra:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Obelisk', glyph: '🗼', tint: 0xE0A52E, weight: 2, textureAlias: 'eye_of_ra:seven',
        winVideoAlias: 'eye_of_ra:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Sun Gem', glyph: '💛', tint: 0xF2C23A, weight: 2.5, textureAlias: 'eye_of_ra:gem',
        winVideoAlias: 'eye_of_ra:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Eye of Ra', glyph: '𓂀', tint: 0xF2C23A, weight: 0.5, textureAlias: 'eye_of_ra:scatter',
        winVideoAlias: 'eye_of_ra:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Sun Hoard', glyph: '🪙', tint: 0xf2c23a, weight: 1, textureAlias: 'eye_of_ra:money',
        winVideoAlias: 'eye_of_ra:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a1c0a, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xf2c23a, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xfff0b0, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a1c0a, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe0682e, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xf2c23a, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xfff0b0, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x2a1c0a, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xfff0b0, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf2c23a, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xfff0b0, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xfff0b0, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'eye_of_ra:bg', path: 'environment/eye_of_ra.png' },
      columnBackground: { alias: 'eye_of_ra:column_bg', path: 'reel/eye_of_ra_column_bg.png' },
      border: { alias: 'eye_of_ra:border', path: 'brand/border_egypt.png' },
    },
  },
};
